import PropTypes from 'prop-types';
import { ChatCircle } from '@phosphor-icons/react/dist/ssr/ChatCircle';
import { X } from '@phosphor-icons/react/dist/ssr/X';

/**
 * SendMessagePrompt — the TEXT variant's ONE-SHOT follow-up prompt (plan 2,
 * epic §4/§9): a chip row under the connection's card once the number has
 * arrived. Chip styling mirrors the JustFormedCard photo chip. X or send
 * retires it FOR GOOD upstream (assume handled — a persisting prompt
 * suggests un-sent and invites repeats); recovery is the text icon on the
 * connection detail page.
 */
const SendMessagePrompt = ({ name, verb = 'Text', onSend, onDismiss }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      padding: '0 16px',
      marginTop: '-4px',
    }}
  >
    {/* Black + centered + COMPACT, "Text {name}" (user rulings, device pass
        1h/1i — primary treatment at chip scale) */}
    <div
      onClick={onSend}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '9px 16px',
        backgroundColor: '#000000',
        borderRadius: '20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
        fontSize: '15px',
        fontWeight: '500',
        color: '#FFFFFF',
        cursor: 'pointer',
      }}
    >
      <ChatCircle size={16} color="#FFFFFF" />
      {name ? `${verb} ${name}` : 'Send a message'}
    </div>
    <div onClick={onDismiss} style={{ padding: '6px', cursor: 'pointer', display: 'flex' }}>
      <X size={16} color="#C2C2C8" />
    </div>
  </div>
);

SendMessagePrompt.propTypes = {
  name: PropTypes.string,
  // 'Text' for a phone channel, 'Message' for a social/email DM
  verb: PropTypes.string,
  onSend: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default SendMessagePrompt;
